import React, { useState } from 'react';
import { Button } from './ui/Button';
import { Input } from './ui/Input';
import { Textarea } from './ui/Textarea';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from './ui/Card';
import { CheckCircle2, Send } from 'lucide-react';
export function ContactForm() {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simulate API call
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSubmitted(true);
    }, 1500);
  };
  if (isSubmitted) {
    return <Card className="w-full max-w-lg mx-auto border-green-100 bg-green-50/50 shadow-xl" data-id="element-23">
        <CardContent className="flex flex-col items-center justify-center py-16 text-center" data-id="element-24">
          <div className="h-20 w-20 rounded-full bg-green-100 flex items-center justify-center mb-6 shadow-sm" data-id="element-25">
            <CheckCircle2 className="h-10 w-10 text-green-600" data-id="element-26" />
          </div>
          <h3 className="text-2xl font-bold text-slate-900 mb-3" data-id="element-27">
            Nachricht gesendet!
          </h3>
          <p className="text-slate-600 mb-8 max-w-xs mx-auto" data-id="element-28">
            Vielen Dank für Ihre Anfrage. Unser Expertenteam wird sich innerhalb
            von 24 Stunden bei Ihnen melden.
          </p>
          <Button onClick={() => setIsSubmitted(false)} variant="outline" className="bg-white hover:bg-green-50 border-green-200 text-green-700" data-id="element-29">
            Neue Nachricht senden
          </Button>
        </CardContent>
      </Card>;
  }
  return <Card className="w-full max-w-lg mx-auto shadow-2xl border-slate-100 overflow-hidden" data-id="element-30">
      <div className="h-2 bg-gradient-to-r from-blue-600 to-indigo-600" data-id="element-31"></div>
      <CardHeader className="pb-8" data-id="element-32">
        <CardTitle className="text-2xl" data-id="element-33">Kontakt aufnehmen</CardTitle>
        <CardDescription className="text-base mt-2" data-id="element-34">
          Haben Sie Fragen? Füllen Sie das Formular aus und wir helfen Ihnen
          gerne weiter.
        </CardDescription>
      </CardHeader>
      <CardContent data-id="element-35">
        <form onSubmit={handleSubmit} className="space-y-5" data-id="element-36">
          <div className="grid grid-cols-2 gap-5" data-id="element-37">
            <div className="space-y-2" data-id="element-38">
              <label htmlFor="firstName" className="text-sm font-semibold text-slate-700" data-id="element-39">
                Vorname
              </label>
              <Input id="firstName" placeholder="Max" required className="h-11 bg-slate-50 focus:bg-white transition-colors" data-id="element-40" />
            </div>
            <div className="space-y-2" data-id="element-41">
              <label htmlFor="lastName" className="text-sm font-semibold text-slate-700" data-id="element-42">
                Nachname
              </label>
              <Input id="lastName" placeholder="Mustermann" required className="h-11 bg-slate-50 focus:bg-white transition-colors" data-id="element-43" />
            </div>
          </div>

          <div className="space-y-2" data-id="element-44">
            <label htmlFor="email" className="text-sm font-semibold text-slate-700" data-id="element-45">
              E-Mail
            </label>
            <Input id="email" type="email" placeholder="max@beispiel.de" required className="h-11 bg-slate-50 focus:bg-white transition-colors" data-id="element-46" />
          </div>

          <div className="space-y-2" data-id="element-47">
            <label htmlFor="subject" className="text-sm font-semibold text-slate-700" data-id="element-48">
              Betreff
            </label>
            <Input id="subject" placeholder="Worum geht es?" required className="h-11 bg-slate-50 focus:bg-white transition-colors" data-id="element-49" />
          </div>

          <div className="space-y-2" data-id="element-50">
            <label htmlFor="message" className="text-sm font-semibold text-slate-700" data-id="element-51">
              Nachricht
            </label>
            <Textarea id="message" placeholder="Ihre Nachricht an uns..." className="min-h-[140px] bg-slate-50 focus:bg-white transition-colors resize-none" required data-id="element-52" />
          </div>

          <Button type="submit" className="w-full h-12 text-base" variant="premium" disabled={isSubmitting} data-id="element-53">
            {isSubmitting ? 'Wird gesendet...' : <span className="flex items-center gap-2" data-id="element-54">
                Nachricht senden <Send className="h-4 w-4" data-id="element-55" />
              </span>}
          </Button>

          <p className="text-xs text-center text-slate-400 mt-4" data-id="element-56">
            Ihre Daten werden sicher und verschlüsselt übertragen.
          </p>
        </form>
      </CardContent>
    </Card>;
}